import { useEffect, useContext } from 'react';
import { useClient } from '../utils/prismicConfig';
import { AppStateContext } from '../components/contexts/AppStateContext';
import { useLocation, useNavigate } from 'react-router-dom';

const linkResolver = (doc) => {
  if (doc.type === 'page') {
    if (doc?.tags.includes('summa-arvo-ohje')) {
      return '/summa-arvot/instructions';
    }

    return `/pages/${doc.id}`;
  } else if (doc.type === 'page_free') {
    return `/pages/${doc.id}`;
  } else if (doc.type === 'home') {
    return '/';
  } else if (doc.type === 'privacy_policy') {
    return '/privacy-policy';
  } else if (doc.type === 'about') {
    return '/about';
  } else if (doc.type === 'terms_and_conditions_summa_arvot') {
    return '/summa-arvot-terms';
  } else if (doc.type === 'terms_and_conditions_maastotaulu') {
    return '/maastotaulukot-terms';
  }

  return '/';
};

const Preview = () => {
  const [appState] = useContext(AppStateContext);
  const client = useClient(appState);
  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      client
        ?.resolvePreviewURL({
          linkResolver,
          defaultUrl: '/',
        })
        .then((url) => navigate(url));
    } catch (e) {
      console.log(e);
    }
  }, [navigate, search, client]);

  return null;
};

export default Preview;
